(() => {
  const header = document.querySelector('.orbi-brand-header');
  const updateHeader = () => header?.classList.toggle('is-scrolled', scrollY > 24);
  updateHeader();
  addEventListener('scroll', updateHeader, { passive: true });

  const params = new URLSearchParams(location.search);
  ['utm_source', 'utm_campaign', 'utm_content'].forEach((key) => {
    const incoming = params.get(key);
    if (incoming) sessionStorage.setItem(`orbi_${key}`, incoming);
    document.querySelectorAll(`[data-utm="${key}"]`).forEach((input) => {
      input.value = incoming || sessionStorage.getItem(`orbi_${key}`) || '';
    });
  });

  document.querySelectorAll('[data-quantity-change]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      input.value = Math.max(1, Number(input.value || 1) + Number(button.dataset.quantityChange));
      document.querySelectorAll('[data-mobile-quantity-value]').forEach((value) => value.textContent = input.value);
    });
  });

  const mainImage = document.querySelector('.reservation-gallery__desktop-image');
  const mediaButtons = [...document.querySelectorAll('[data-media-src]')];
  let activeMedia = Math.max(0, mediaButtons.findIndex((button) => button.classList.contains('is-active')));
  const showMedia = (index) => {
    if (!mainImage || !mediaButtons.length) return;
    activeMedia = (index + mediaButtons.length) % mediaButtons.length;
    mainImage.src = mediaButtons[activeMedia].dataset.mediaSrc;
    mediaButtons.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeMedia));
    document.querySelectorAll('[data-gallery-dot]').forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeMedia));
  };
  mediaButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      showMedia(index);
    });
  });
  document.querySelectorAll('[data-gallery-arrow]').forEach((button) => {
    button.addEventListener('click', () => showMedia(activeMedia + Number(button.dataset.galleryArrow)));
  });
  document.querySelectorAll('[data-gallery-dot]').forEach((dot) => dot.addEventListener('click', () => showMedia(Number(dot.dataset.galleryDot))));

  const mobileTrack = document.querySelector('.reservation-gallery__mobile-track');
  const mobileSlides = [...document.querySelectorAll('.reservation-gallery__mobile-track img')];
  const showMobileSlide = (index, behavior = 'smooth') => {
    if (!mobileTrack || !mobileSlides.length) return;
    activeMedia = (index + mobileSlides.length) % mobileSlides.length;
    mobileTrack.scrollTo({ left: activeMedia * mobileTrack.clientWidth, behavior });
    document.querySelectorAll('[data-gallery-dot]').forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeMedia));
  };
  let mobileScrollTimer;
  mobileTrack?.addEventListener('scroll', () => {
    clearTimeout(mobileScrollTimer);
    mobileScrollTimer = setTimeout(() => {
      activeMedia = Math.round(mobileTrack.scrollLeft / mobileTrack.clientWidth);
      document.querySelectorAll('[data-gallery-dot]').forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeMedia));
    }, 80);
  }, { passive: true });
  document.querySelectorAll('[data-gallery-dot]').forEach((dot) => dot.addEventListener('click', () => showMobileSlide(Number(dot.dataset.galleryDot))));

  let carouselTimer;
  const restartCarousel = () => {
    clearInterval(carouselTimer);
    if (matchMedia('(max-width: 820px)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      carouselTimer = setInterval(() => showMobileSlide(activeMedia + 1), 5000);
    }
  };
  mobileTrack?.addEventListener('pointerdown', () => clearInterval(carouselTimer), { passive: true });
  mobileTrack?.addEventListener('pointerup', restartCarousel, { passive: true });
  restartCarousel();

  const quantityInput = document.querySelector('.reservation-form input[name="quantity"]');
  document.querySelectorAll('[data-mobile-quantity]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + Number(button.dataset.mobileQuantity));
      document.querySelectorAll('[data-mobile-quantity-value]').forEach((value) => value.textContent = quantityInput.value);
    });
  });
  quantityInput?.addEventListener('input', () => {
    document.querySelectorAll('[data-mobile-quantity-value]').forEach((value) => value.textContent = quantityInput.value || '1');
  });
  document.querySelectorAll('[data-mobile-purchase]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelector(`.reservation-form [name="${button.dataset.mobilePurchase}"]`)?.click();
    });
  });

  const productForm = document.querySelector('.reservation-form');
  const isLocalPreview = ['127.0.0.1', 'localhost'].includes(location.hostname);
  productForm?.addEventListener('submit', async (event) => {
    const action = event.submitter?.name;
    if (action !== 'checkout') return;
    event.preventDefault();
    const button = event.submitter;
    button.disabled = true;
    try {
      if (isLocalPreview) {
        button.textContent = 'Checkout preview';
      } else {
        const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(productForm), headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Unable to add deposit');
        const positioning = productForm.dataset.positioning;
        const attributes = {
          positioning,
          utm_source: productForm.querySelector('[data-utm="utm_source"]')?.value || '',
          utm_campaign: productForm.querySelector('[data-utm="utm_campaign"]')?.value || '',
          utm_content: productForm.querySelector('[data-utm="utm_content"]')?.value || positioning,
          landing_page: location.pathname
        };
        const update = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes })
        });
        if (!update.ok) throw new Error('Unable to save reservation attribution');
        location.assign('/checkout');
      }
    } finally {
      button.disabled = false;
    }
  });
  const inlineReserve = document.querySelector('.reservation-form [name="checkout"]');
  const mobileBar = document.querySelector('[data-mobile-purchase-bar]');
  if (inlineReserve && mobileBar) {
    const updateMobileBar = () => {
      const reserveBottom = inlineReserve.getBoundingClientRect().bottom;
      mobileBar.classList.toggle('is-visible', scrollY > 0 && reserveBottom < 0);
    };
    updateMobileBar();
    addEventListener('scroll', updateMobileBar, { passive: true });
  }

  const featureRail = document.querySelector('.reservation-feature-grid');
  document.querySelectorAll('[data-feature-arrow]').forEach((button) => {
    button.addEventListener('click', () => {
      const card = featureRail?.querySelector('.reservation-feature-card');
      featureRail?.scrollBy({ left: Number(button.dataset.featureArrow) * ((card?.getBoundingClientRect().width || 300) + 14), behavior: 'smooth' });
    });
  });
})();
